/**
 * Which "mode" a particular page lives in.
 */
export enum UserMode {
  Educator = "educator",
  Parent = "parent"
}
